export default "__VITE_ASSET__fnfwTcW1__"